import { SET_LOADING } from '../actions/loadingAction';

const initialState = {
    loading: false,
    tip: '',
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case SET_LOADING:
            return { ...state, loading: action.loading, tip: action.tip };
        default:
            return state;
    }
}
